import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, IconButton, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";

export const ScheduleVsActualHeader: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const { chosenDepartment } = useHospitalData();

	const handleBack = () => {
		const qs = searchParams.toString();
		navigate(`/${chosenDepartment.department_id}/management-center${qs ? `?${qs}` : ""}`);
	};

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				width: "100%",
				mb: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 1,
				}}
			>
				<IconButton onClick={handleBack}>
					<ArrowBackIcon />
				</IconButton>
				<Typography
					variant="h6"
					sx={{
						fontWeight: 600,
					}}
				>
					{t("schedule.vs.actual.report")}
				</Typography>
			</Box>
		</Box>
	);
};
